import { createContext, useContext } from "react";

type BaseAsset = {
  code: string;
  precision: number;
  stepSize: string;
};

type QuoteAsset = {
  code: string;
  precision: number;
  tickSize: string;
};

export type Product = {
  id: string;
  symbol: string;
  base: BaseAsset;
  quote: QuoteAsset;
  minOrderValueUsd: number; // Minimum USD notional value per order (e.g., 10 means $10 minimum)
};

type ProductContextType = {
  product?: Product;
  setProduct: (product: Product) => void;
};

export const ProductContext = createContext<ProductContextType | undefined>(
  undefined
);

export const useProduct = () => {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error("useProduct must be used within a ProductProvider");
  }
  return context;
};
